import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=7274f267&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7274f267')) {
      api.createRecord('7274f267', component.options)
    } else {
      api.reload('7274f267', component.options)
    }
    module.hot.accept("./pager.vue?vue&type=template&id=7274f267&", function () {
      api.rerender('7274f267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/pagination/src/pager.vue"
export default component.exports